module.exports = __webpack_public_path__ + "img/L_298_0.b93e4724.png";